"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var assert_1 = require("@0x/assert");
var connect_1 = require("@0x/connect");
var utils_1 = require("@0x/utils");
var order_set_1 = require("../order_set");
var order_store_1 = require("../order_store");
var utils_2 = require("../utils");
var base_sra_order_provider_1 = require("./base_sra_order_provider");
var SRAWebsocketOrderProvider = /** @class */ (function (_super) {
    __extends(SRAWebsocketOrderProvider, _super);
    /**
     * Instantiates a HTTP and WS [Standard Relayer API](https://github.com/0xProject/standard-relayer-api) Order Provider
     * @param opts `SRAWebsocketOrderProviderOpts` containing the websocketEndpoint and the httpEndpoint to an SRA backend.
     * @param orderStore The `OrderStore` where orders are added and removed from
     */
    function SRAWebsocketOrderProvider(opts, orderStore) {
        var _this = _super.call(this, orderStore, opts.httpEndpoint, base_sra_order_provider_1.PER_PAGE_DEFAULT) || this;
        _this._wsSubscriptions = new Map();
        _this._isDestroyed = false;
        _this._isConnecting = false;
        assert_1.assert.isUri('websocketEndpoint', opts.websocketEndpoint);
        _this._websocketEndpoint = opts.websocketEndpoint;
        return _this;
    }
    /**
     * Creates a websocket subscription and fetches the current orders from SRA. If a websocket
     * connection already exists this function is a noop.
     * @param makerAssetData the Maker Asset Data
     * @param takerAssetData the Taker Asset Data
     */
    SRAWebsocketOrderProvider.prototype.createSubscriptionForAssetPairAsync = function (makerAssetData, takerAssetData) {
        return __awaiter(this, void 0, void 0, function () {
            var assetPairKey;
            return __generator(this, function (_a) {
                // If we've previously been destroyed then reset
                this._isDestroyed = false;
                assetPairKey = order_store_1.OrderStore.getKeyForAssetPair(makerAssetData, takerAssetData);
                if (this._wsSubscriptions.has(assetPairKey)) {
                    return [2 /*return*/];
                }
                return [2 /*return*/, this._fetchAndCreateSubscriptionAsync(makerAssetData, takerAssetData)];
            });
        });
    };
    /**
     * Destroys the order provider, removing any subscriptions
     */
    SRAWebsocketOrderProvider.prototype.destroyAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._isDestroyed = true;
                this._wsSubscriptions.clear();
                if (this._ordersChannel) {
                    this._ordersChannel.close();
                    this._ordersChannel = undefined;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Creates a websocket subscription. If the inital websocket connnection
     * does not exist, it is created.
     * @param makerAssetData the Maker Asset Data
     * @param takerAssetData the Taker Asset Data
     */
    SRAWebsocketOrderProvider.prototype._createWebsocketSubscriptionAsync = function (makerAssetData, takerAssetData) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, assetPairKey, subscriptionOpts;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this._isConnecting && !this._ordersChannel)) return [3 /*break*/, 2];
                        return [4 /*yield*/, utils_2.utils.delayAsync(100)];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 0];
                    case 2:
                        if (!!this._ordersChannel) return [3 /*break*/, 6];
                        this._isConnecting = true;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, , 5, 6]);
                        _a = this;
                        return [4 /*yield*/, this._createOrdersChannelAsync()];
                    case 4:
                        _a._ordersChannel = _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this._isConnecting = false;
                        return [7 /*endfinally*/];
                    case 6:
                        assetPairKey = order_store_1.OrderStore.getKeyForAssetPair(makerAssetData, takerAssetData);
                        subscriptionOpts = {
                            makerAssetData: makerAssetData,
                            takerAssetData: takerAssetData,
                        };
                        this._wsSubscriptions.set(assetPairKey, subscriptionOpts);
                        // Subscribe to both sides of the book
                        this._ordersChannel.subscribe(subscriptionOpts);
                        this._ordersChannel.subscribe(__assign({}, subscriptionOpts, { makerAssetData: takerAssetData, takerAssetData: makerAssetData }));
                        return [2 /*return*/];
                }
            });
        });
    };
    SRAWebsocketOrderProvider.prototype._fetchAndCreateSubscriptionAsync = function (makerAssetData, takerAssetData) {
        return __awaiter(this, void 0, void 0, function () {
            var orders, assetPairKey, currentOrders, newOrders, diff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Create the subscription first to get any updates while waiting for the request
                    return [4 /*yield*/, this._createWebsocketSubscriptionAsync(makerAssetData, takerAssetData)];
                    case 1:
                        // Create the subscription first to get any updates while waiting for the request
                        _a.sent();
                        return [4 /*yield*/, this._fetchLatestOrdersAsync(makerAssetData, takerAssetData)];
                    case 2:
                        orders = _a.sent();
                        assetPairKey = order_store_1.OrderStore.getKeyForAssetPair(makerAssetData, takerAssetData);
                        currentOrders = this._orderStore.getOrderSetForAssetPair(assetPairKey);
                        newOrders = new order_set_1.OrderSet();
                        return [4 /*yield*/, newOrders.addManyAsync(orders)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, currentOrders.diffAsync(newOrders)];
                    case 4:
                        diff = _a.sent();
                        return [4 /*yield*/, this._updateStoreAsync({
                                added: diff.added,
                                removed: diff.removed,
                                assetPairKey: assetPairKey,
                            })];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SRAWebsocketOrderProvider.prototype._syncOrdersInOrderStoreAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, _a, _b, _c, assetPairKey, _d, assetDataA, assetDataB, e_1_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 5, 6, 7]);
                        _b = __values(this._orderStore.keys()), _c = _b.next();
                        _e.label = 1;
                    case 1:
                        if (!!_c.done) return [3 /*break*/, 4];
                        assetPairKey = _c.value;
                        _d = __read(order_store_1.OrderStore.assetPairKeyToAssets(assetPairKey), 2), assetDataA = _d[0], assetDataB = _d[1];
                        return [4 /*yield*/, this._fetchAndCreateSubscriptionAsync(assetDataA, assetDataB)];
                    case 2:
                        _e.sent();
                        _e.label = 3;
                    case 3:
                        _c = _b.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_1_1 = _e.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates a new websocket orders channel.
     */
    SRAWebsocketOrderProvider.prototype._createOrdersChannelAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ordersChannelHandler, e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ordersChannelHandler = {
                            onUpdate: function (_channel, _opts, apiOrders) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                return [2 /*return*/, this._handleOrderUpdatesAsync(apiOrders)];
                            }); }); },
                            // tslint:disable-next-line:no-empty
                            onError: function (_channel, _err) { },
                            onClose: function () { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            // Do not reconnect if destroyed
                                            if (this._isDestroyed) {
                                                return [2 /*return*/];
                                            }
                                            // Re-sync and create subscriptions
                                            return [4 /*yield*/, utils_2.utils.attemptAsync(function () { return __awaiter(_this, void 0, void 0, function () {
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0:
                                                                this._ordersChannel = undefined;
                                                                return [4 /*yield*/, this._syncOrdersInOrderStoreAsync()];
                                                            case 1:
                                                                _a.sent();
                                                                return [2 /*return*/, true];
                                                        }
                                                    });
                                                }); })];
                                        case 1:
                                            // Re-sync and create subscriptions
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); },
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, connect_1.ordersChannelFactory.createWebSocketOrdersChannelAsync(this._websocketEndpoint, ordersChannelHandler)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_2 = _a.sent();
                        throw new Error("Creating websocket connection to " + this._websocketEndpoint);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handles updates from the websocket, adding new orders and removing orders
     * which have remainingFillableTakerAssetAmount as 0.
     * @param orders the set of API Orders returned from the websocket channel
     */
    SRAWebsocketOrderProvider.prototype._handleOrderUpdatesAsync = function (orders) {
        return __awaiter(this, void 0, void 0, function () {
            var e_3, _a, e_4, _b, addedRemovedByKey, orders_1, orders_1_1, order, assetPairKey, addedRemoved, remainingFillableTakerAssetAmount, _c, _d, assetPairKey, e_4_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        addedRemovedByKey = {};
                        try {
                            for (orders_1 = __values(orders), orders_1_1 = orders_1.next(); !orders_1_1.done; orders_1_1 = orders_1.next()) {
                                order = orders_1_1.value;
                                assetPairKey = order_store_1.OrderStore.getKeyForAssetPair(order.order.makerAssetData, order.order.takerAssetData);
                                if (!addedRemovedByKey[assetPairKey]) {
                                    addedRemovedByKey[assetPairKey] = { added: [], removed: [], assetPairKey: assetPairKey };
                                }
                                addedRemoved = addedRemovedByKey[assetPairKey];
                                remainingFillableTakerAssetAmount = order.metaData.remainingFillableTakerAssetAmount;
                                if (remainingFillableTakerAssetAmount && new utils_1.BigNumber(remainingFillableTakerAssetAmount).eq(0)) {
                                    addedRemoved.removed.push(order);
                                }
                                else {
                                    addedRemoved.added.push(order);
                                }
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (orders_1_1 && !orders_1_1.done && (_a = orders_1.return)) _a.call(orders_1);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 6, 7, 8]);
                        _c = __values(Object.keys(addedRemovedByKey)), _d = _c.next();
                        _e.label = 2;
                    case 2:
                        if (!!_d.done) return [3 /*break*/, 5];
                        assetPairKey = _d.value;
                        return [4 /*yield*/, this._updateStoreAsync(addedRemovedByKey[assetPairKey])];
                    case 3:
                        _e.sent();
                        _e.label = 4;
                    case 4:
                        _d = _c.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_4_1 = _e.sent();
                        e_4 = { error: e_4_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    return SRAWebsocketOrderProvider;
}(base_sra_order_provider_1.BaseSRAOrderProvider));
exports.SRAWebsocketOrderProvider = SRAWebsocketOrderProvider;
//# sourceMappingURL=sra_websocket_order_provider.js.map